<div class="car-detail-electro-stats">
  <!-- <div class="car-detail-electro-stats__header">
    <div class="car-detail-electro-stats__header-item car-detail-electro-stats__header-item--green">
      <div class="car-detail-electro-stats__header-content">{{ 'carDetail.electroStats.battery' | translate }}: {{ car?.evProperties?.batterySOH }}%</div>
      <div class="car-detail-electro-stats__header-icon">
        <app-icon [icon]="'info'" [width]="24"></app-icon>
      </div>
    </div>
    <div class="car-detail-electro-stats__header-item car-detail-electro-stats__header-item--blue">
      <div class="car-detail-electro-stats__header-content"><app-image [src]="'images/aviloo-logo.svg'" [alt]="'Aviloo'" [width]="60" [height]="24"></app-image> Score: 84/100</div>
      TODO:
      <div class="car-detail-electro-stats__header-icon">
        <app-icon [icon]="'pdf-download'" [width]="24"></app-icon>
      </div>
    </div>
  </div> -->
  <div class="car-detail-electro-stats__main">
    <div class="car-detail-electro-stats__stats">
      @if (car) {
        @if (car.evProperties.batteryCapacity) {
          <app-car-detail-electro-stats-item [label]="'carDetail.electroStats.batteryCapacity' | translate">{{ car.evProperties.batteryCapacity | floatNumber }} kWh</app-car-detail-electro-stats-item>
        }
        @if (car.evProperties.chargingPublicAc || car.evProperties.chargingPublicDc) {
          <app-car-detail-electro-stats-item [label]="'carDetail.electroStats.charging' | translate">
            @if (car.evProperties.chargingPublicAc) {
              {{ 'globals.until' | translate | lowercase }} {{ car.evProperties.chargingPublicAc }} kW AC
            }
            {{ car.evProperties.chargingPublicAc && car.evProperties.chargingPublicDc ? ' / ' : '' }}
            @if (car.evProperties.chargingPublicDc) {
              {{ 'globals.until' | translate | lowercase }} {{ car.evProperties.chargingPublicDc }} kW DC
            }
          </app-car-detail-electro-stats-item>
        }
        @if (car.evProperties.consumption) {
          <app-car-detail-electro-stats-item [label]="'carDetail.electroStats.consumption' | translate">{{ car.evProperties.consumption | floatNumber }} kWh/100 km (WLTP)</app-car-detail-electro-stats-item>
        }
        @if (car.evProperties.batteryWarrantyTo || car.evProperties.batteryWarrantyKm) {
          <app-car-detail-electro-stats-item [label]="'carDetail.electroStats.warranty' | translate">
            @if (car.evProperties.batteryWarrantyTo) {
              {{ 'globals.to' | translate | lowercase }} {{ car.evProperties.batteryWarrantyTo | dateFormat }}
            }
            @if (car.evProperties.batteryWarrantyTo && car.evProperties.batteryWarrantyKm) {
              {{ 'globals.or' | translate | lowercase }}
            }
            @if (car.evProperties.batteryWarrantyKm) {
              {{ car.evProperties.batteryWarrantyKm | thousands }} km
            }
          </app-car-detail-electro-stats-item>
        }
        @if (car.evProperties.range) {
          <app-car-detail-electro-stats-item [label]="'carDetail.electroStats.range' | translate">{{ car.evProperties.range }} km (WLTP)</app-car-detail-electro-stats-item>
        }
        <!--<app-car-detail-electro-stats-item [label]="'carDetail.electroStats.powerOutput' | translate">3,3 kW</app-car-detail-electro-stats-item>-->
        <!-- TODO: -->
      }
    </div>
    <div class="car-detail-electro-stats__info">
      <div class="car-detail-electro-stats__info-content">
        @if (car?.evProperties?.evConnectorTypeCodes) {
          <div class="car-detail-electro-stats__info-item">
            {{ 'carDetail.electroStats.connectorType' | translate }}
            @for (connector of car?.evProperties?.evConnectorTypeCodes; track connector.title) {
              <div class="car-detail-electro-stats__box">
                {{ connector.title }}
                <app-image [src]="'/images/connector-dc.svg'" [alt]="connector.title ?? ''" [width]="25" [height]="34"></app-image>
                <!--<app-image [src]="'/images/connector-mennekes.svg'" [alt]="connector.title ?? ''" [width]="25" [height]="24"></app-image>-->
                <!-- TODO: -->
              </div>
            }
          </div>
        }
        @if (car?.equipmentFinal?.ev?.items?.length) {
          <div class="car-detail-electro-stats__info-item">
            {{ 'carDetail.electroStats.equipment' | translate }}
            <app-paragraph class="car-detail-electro-stats__info-text">
              @for (item of car?.equipmentFinal?.ev?.items; track item.id) {
                {{ item.title }}
              }
            </app-paragraph>
          </div>
        }
      </div>
    </div>
  </div>
</div>
